import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import store from "./store/store";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById("root"));
// const themeSelect = useSelector((state) => state.themeSelector.theme);
// document.body.style = "background: #e9ecf1;";

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
